<template>
    <div>
        <span v-if="this.add" @click="addItem" class="icon icon-add"></span>
        <span v-if="this.copy" @click="copyItem" class="icon icon-duplicate"></span>
        <span v-if="this.delete" @click="deleteItem" class="icon icon-delete"></span>
    </div>
</template>

<script>
    export default {
        name: "IconBox",
        props: {
            add: {
                type: Boolean,
                default: true
            },
            copy: {
                type: Boolean,
                default: true
            },
            delete: {
                type: Boolean,
                default: true
            },
        },
        methods:{
            addItem:function () {
                this.$emit('addItem');
            },
            copyItem:function () {
                this.$emit('copyItem');
            },
            deleteItem:function () {
                this.$emit('deleteItem');
            }
        }
    }
</script>

<style scoped>
    .icon{
        cursor: pointer;
        padding-left: .5em;
        font-size: 1.5em;
    }
</style>